import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AccessService } from './access.service';

@Injectable()
export class AuthGuard implements CanActivate {

	constructor(
		private access: AccessService,
		private router: Router
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.access.user_data != null) {
			return true;
		}
		this.access.redirect_url = state.url;
		this.router.navigate(['/login']);
		return false;
	}
}
